import type { LoyaltyCouponSeries } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleLoyaltyCouponSeriesQuery {
  loyaltyCouponSeries: LoyaltyCouponSeries
}

export interface SingleLoyaltyCouponSeriesQueryVariables {
  id: GQL_ID
}

export const GQL_QUERY_SINGLE_LOYALTY_COUPON_SERIES = gql`
  query($id: ID!) {
    loyaltyCouponSeries: singleLoyaltyCouponSeries(id: $id) {
      ${SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS}
    }
  }
`

export const useFetchSingleLoyaltyCouponSeries = (
  variables: SingleLoyaltyCouponSeriesQueryVariables
) =>
  useQuery<SingleLoyaltyCouponSeriesQuery, SingleLoyaltyCouponSeriesQueryVariables>(
    GQL_QUERY_SINGLE_LOYALTY_COUPON_SERIES,
    {
      variables,
      skip: !variables.id
    }
  )
